.nav {
    --clickable-height: 32px;

    composes: safeContainer from "../../styles/composable/layout.module.css";
    display: flex;
    justify-content: center;
    gap: var(--spacer-4);
    padding-top: var(--spacer-24);
    font: var(--font-p-12);
}

.step {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: var(--clickable-height);
}

.stepDisabled {
    composes: step;
    color: var(--gray-700);
}

.arrow {
    width: 16px;
    height: 16px;
}

.arrowPrev {
    composes: arrow;
    scale: -1 1;
}

.arrowNext {
    composes: arrow;
}

.page {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: var(--clickable-height);
    border: 1px solid transparent;
    color: var(--gray-500);
}

.ellipsis {
    composes: page;
    width: 24px;
    translate: 0 -4px;
    scale: 1.15;
}

.currentPage {
    composes: page;
    border-color: var(--color-contrast);
    border-radius: var(--border-radius-full);
    color: var(--color-contrast);
    cursor: default;
}

.pageLink {
    composes: page;
}
